<template>
	<div v-if="this.$store.state.companyInfoLoading" class="spinner-border" />
	<div class="accordion" id="accordionComments">
		<div class="accordion-item" :key="item.ID" v-for="(item, i) in items">
			<h2 class="accordion-header">
				<button class="accordion-button" :class="{collapsed: i>0}" :aria-expanded="i === 0" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse'+i" :aria-controls="'collapse'+i">
					Комментарий от {{ getFormattedDate(item.CREATED) }}
				</button>
			</h2>
			<div :id="'collapse'+i" class="accordion-collapse collapse" :class="{show: i===0}" data-bs-parent="#accordionComments">
				<div class="accordion-body">
					<div>Автор <strong>{{ item.user }}</strong></div>
					<div>{{ item.COMMENT }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'Comments',
	props: {
		items: Array
	},
	computed: {},
	methods: {
		getFormattedDate(date) {
			let fdate = new Date(date)
            return fdate.toLocaleDateString()
        }
	}
}
</script>

<style scoped>
	
</style>